"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DatePicker = require("@mui/x-date-pickers/DatePicker");

var _AdapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");

var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");

var _styles = require("@mui/styles");

var _styles2 = require("@mui/material/styles");

var _Input = _interopRequireDefault(require("../input/Input"));

var theme = (0, _styles2.createTheme)({
  palette: {
    primary: {
      main: '#0245F0',
      light: '#4D6FFF',
      dark: '#000F5E'
    }
  },
  shape: {
    borderRadius: 4
  }
});

var DP = function DP(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDateFns.AdapterDateFns
  }, /*#__PURE__*/_react["default"].createElement(_DatePicker.DatePicker, (0, _extends2["default"])({}, props, {
    renderInput: function renderInput(_ref) {
      var inputRef = _ref.inputRef,
          inputProps = _ref.inputProps,
          InputProps = _ref.InputProps;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.placeholder ? /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, inputProps, {
        ref: inputRef,
        endIcon: InputProps.endAdornment,
        label: props.label,
        placeholder: props.placeholder
      })) : /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, inputProps, {
        ref: inputRef,
        endIcon: InputProps.endAdornment,
        label: props.label
      })));
    }
  }))));
};

DP.propTypes = {
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
var _default = DP;
exports["default"] = _default;